import axios from "../../utils/axios";
import type {
    AcknowledgementRecipientDTO,
    RiskAssessmentVersionHistoryDTO,
} from "../types/scoreMiscDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

// Deferred: returns RiskAssessmentHistoryResponseDTO — the deep RA-history detail
// graph (RiskAssessmentHazardResponseDTO -> Hazard/CustomHazard controls +
// CustomControlDTO, RiskAssessmentPeopleResponseDTO, ActionDTO). Leave untyped.
const saveRiskAssessmentHistory = (riskAssessmentToSave) => axios.post(`${apiUrl}/RiskAssessmentHistory`, riskAssessmentToSave);

const archiveRiskAssessmentHistory = (riskAssessmentHistoryUpdate) =>
    axios.post<void>(`${apiUrl}/riskassessmenthistory/archive/${riskAssessmentHistoryUpdate.archiveRiskAssessmentId}/${riskAssessmentHistoryUpdate.id}`);

const downloadRiskAssessmentPdf = (riskAssessmentId, riskAssessmentHistoryId) =>
    axios.get<Blob>(`${apiUrl}/riskassessmenthistory/downloadpdf/${riskAssessmentId}/${riskAssessmentHistoryId}`, {
        responseType: "blob",
    });

const getRiskAssessmentHistoryAcknowledgementRecipients = (riskAssessmentHistoryId) =>
    axios.get<AcknowledgementRecipientDTO[]>(`${apiUrl}/riskassessmenthistory/acknowledgementrecipients/${riskAssessmentHistoryId}`);

const shareRiskAssessmentHistory = ({ riskAssessmentHistoryId, emailAddresses, isReSend }) =>
    axios.post<void>(`${apiUrl}/riskassessmenthistory/share/${riskAssessmentHistoryId}/${isReSend}`, emailAddresses);

const fetchRiskAssessmentVersionHistory = (riskAssessmentHistoryId) => {
    return axios.get<RiskAssessmentVersionHistoryDTO>(`${apiUrl}/RiskAssessmentVersionHistory/${riskAssessmentHistoryId}`);
}

// Deferred: returns RiskAssessmentHistoryResponseDTO — same deep RA-history
// detail graph as saveRiskAssessmentHistory. Leave untyped.
const fetchRiskAssessmentHistory = (riskAssessmentHistoryId) => {
    return axios.get(`${apiUrl}/RiskAssessmentHistory/${riskAssessmentHistoryId}`);
}

const riskAssessmentHistoryService = {
    saveRiskAssessmentHistory,
    archiveRiskAssessmentHistory,
    downloadRiskAssessmentPdf,
    getRiskAssessmentHistoryAcknowledgementRecipients,
    shareRiskAssessmentHistory,
    fetchRiskAssessmentVersionHistory,
    fetchRiskAssessmentHistory,
};

export default riskAssessmentHistoryService;
